// extracted by mini-css-extract-plugin
export default {"image-container":"JI_ZsJ","imageContainer":"JI_ZsJ","image-wrapper":"xucSpO","imageWrapper":"xucSpO"};